module.exports = "/images/1_f3453f.png";